export function toOptionalBoolean(value) {
  if (value === undefined || value === null || value === '') return undefined;
  if (typeof value === 'boolean') return value;
  if (typeof value === 'number') return value === 1;
  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();
    if (['1', 'true', 'y', 'yes', 'enabled'].includes(normalized)) return true;
    if (['0', 'false', 'n', 'no', 'disabled'].includes(normalized)) return false;
  }
  return undefined;
}

export function extractMediaSettings(res) {
  const candidates = [
    res,
    res?.data,
    res?.data?.coursedetails,
    res?.data?.settings,
    res?.settings,
  ];
  for (const source of candidates) {
    if (!source || typeof source !== 'object') continue;
    const jwplayerStatus = toOptionalBoolean(source.jwplayer_status ?? source.jwplayerStatus);
    const jwSeekDisabledStatus = toOptionalBoolean(
      source.jw_seek_disabled_status ?? source.jwSeekDisabledStatus,
    );
    if (jwplayerStatus !== undefined || jwSeekDisabledStatus !== undefined) {
      return { jwplayerStatus, jwSeekDisabledStatus };
    }
  }
  return null;
}
